var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4204 0.240629C11.1104 0.550628 11.1104 1.06657 11.4204 1.37585L17.2358 7.19068L0.802891 7.19646C0.355556 7.19718 0 7.55271 0 8C0 8.4473 0.355556 8.81438 0.802891 8.81438L17.2358 8.8086L11.4204 14.6126C11.1104 14.9334 11.1104 15.4501 11.4204 15.7594C11.7413 16.0802 12.258 16.0802 12.5673 15.7594L19.7593 8.56797C20.0802 8.25797 20.0802 7.74203 19.7593 7.43275L12.5673 0.240629C12.2573 -0.0802095 11.7413 -0.0802095 11.4204 0.240629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.0cd580a95e59ce737e88cb495944bcb5.svg";
export { ForwardRef as ReactComponent };